import React, { forwardRef } from 'react';

export interface Recipe {
  id: string;
  user_id: string;
  type: 'recipe';
  recipe_name: string;
  description: string;
  ingredients: string[];
  instructions: string[];
  tried: boolean;
  servings: string;
  prep_time: string;
  cook_time: string;
  total_time: string;
  nutrition_info: string;
  average_rating?: string;
  rating_count?: number;
  createdBy: string;
  user_ratings?: {
    [key: string]: number;
  };
}

interface RecipeDetailsProps {
    recipe: Recipe;
    isEditing: boolean;
    onIngredientChange: (index: number, value: string) => void;
    onInstructionChange: (index: number, value: string) => void;
    onSaveRecipe: (updatedData: Recipe) => Promise<void>;
    onEdit: () => void;
}

const RecipeDetails = forwardRef<HTMLDivElement, RecipeDetailsProps>(
    ({ recipe, isEditing, onIngredientChange, onInstructionChange, onSaveRecipe, onEdit }, ref) => {
        
        const handleIngredientsChange = (value: string) => {
            const updatedIngredients = value.split('\n');
            onIngredientChange(0, updatedIngredients.join(', '));
        };

        const handleInstructionsChange = (value: string) => {
            const updatedInstructions = value.split('\n');
            onInstructionChange(0, updatedInstructions.join(', '));
        };

        const ingredientsText = recipe.ingredients.join('\n');
        const instructionsText = recipe.instructions.join('\n');

        return (
            <div className="recipe-details" ref={ref}>
            <div className="recipe-title">
              <h1>{recipe.recipe_name}</h1>
              <p>{recipe.description}</p>
            </div>
    
            <div className="recipe-content">
              <div className="recipe-section">
                <h3>Ingredients</h3>
                {isEditing ? (
                  <textarea
                    value={ingredientsText}
                    onChange={(e) => handleIngredientsChange(e.target.value)}
                    rows={5}
                  />
                ) : (
                    <div className="ingredients-list">
                    {recipe.ingredients?.map((ingredient, index) => (
                        <div key={index}>{ingredient}</div>
                    ))}
                </div>
                )}
              </div>
    
              <div className="recipe-section">
                <h3>Instructions</h3>
                {isEditing ? (
                  <textarea
                    value={instructionsText}
                    onChange={(e) => handleInstructionsChange(e.target.value)}
                    rows={10}
                  />
                ) : (
                    <div className="instructions-list">
                    {recipe.instructions?.map((instruction, index) => (
                        <div key={index}>{instruction}</div>
                    ))}
                </div>
                )}
              </div>
            </div>
            </div>
        );
    }
);

export default RecipeDetails;
